import React, {Component} from 'react'
import {Wedge} from 'react-konva'
import {KonvaEventObject} from 'konva/lib/Node'
import {WedgeElement as WedgeElementData} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: WedgeElementData
    onClick: (event: KonvaEventObject<MouseEvent>) => void
    onTransform: (event: KonvaEventObject<MouseEvent>) => void
    onDrag: (event: KonvaEventObject<DragEvent>) => void
    onRightClick: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
}

export default class WedgeElement extends Component<Props> {
    render() {
        const {element, draggable = true} = this.props
        return (
            <Wedge
                opacity={element.opacity}
                angle={element.angle}
                radius={element.radius}
                fill={element.fill}
                strokeWidth={element.strokeWidth}
                strokeScaleEnabled={false}
                id={element.id}
                key={element.id}
                draggable={draggable}
                stroke={element.stroke}
                x={element.x}
                y={element.y}
                scaleX={element.scaleX}
                scaleY={element.scaleY}
                rotation={element.rotation}
                onClick={this.props.onClick}
                onTransform={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}/>
        )
    }
}
